export default "__VITE_ASSET__c94305cc__"